/**
* @Description: applyUpdate
* @author XuZiYu
* @date 2021-07-19 15:03
*/
<template>
  <div class="wrapper">
    <ctl-header :title="'修改申请信息'" :headerFixed="headerFixed"></ctl-header>
    <van-cell-group class="main">
      <van-field
        readonly
        input-align="right"
        label="补偿科目"
      >
        <div slot="input">{{form.subjectName}}</div>
      </van-field>
      <van-field
        readonly
        input-align="right"
        v-model="form.examCityCode"
        label="考试所在城市"
      >
      </van-field>
      <van-field
        input-align="right"
        v-model="form.stuName"
        label="学员姓名"
        readonly
      >
      </van-field>
      <van-field
        input-align="right"
        label="证件号"
        readonly
      >
        <div slot="input">
          {{form.stuIdcard}}
        </div>
      </van-field>
      <div class="cell-title">
        收款账号
      </div>
      <van-field
        @click="collectTypeShow = true"
        size="large"
        input-align="right"
        v-model="form.collectTypeName"
        readonly
        label="收款方式"
        placeholder="请选择收款方式"
        right-icon="arrow"
      >
        <div v-if="form.collectType === 5" class="yhk-value " slot="input">银行卡</div>
        <div v-if="form.collectType === 2" class="zfb-value" slot="input">支付宝</div>
      </van-field>
      <template v-if="form.collectType === 2">
        <van-field
          rows="1"
          autosize
          type="textarea"
          class="update"
          input-align="right"
          v-model="form.alibNo"
          label="支付宝账号"
          maxlength="30"
          clearable
          placeholder="请输入本人支付宝账号"
          @focus="headerFixed = false"
          @blur="headerFixed = true"
        >
        </van-field>
        <van-field
          rows="1"
          autosize
          type="textarea"
          class="update"
          input-align="right"
          v-model="form.alibName"
          label="支付宝实名"
          maxlength="30"
          clearable
          placeholder="请输入支付宝实名"
          @focus="headerFixed = false"
          @blur="headerFixed = true"
        >
        </van-field>
      </template>
      <template v-if="form.collectType === 5">
        <van-field
          class="update"
          input-align="right"
          v-model="form.bankcardNo"
          label="银行卡号"
          maxlength="24"
          placeholder="请输入本人银行卡号"
          clearable
          @focus="headerFixed = false"
          @blur="headerFixed = true"
        >
        </van-field>
        <van-field
          class="update"
          input-align="right"
          v-model="form.bankName"
          label="开户行"
          maxlength="20"
          placeholder="请输入开户银行"
          clearable
          @focus="headerFixed = false"
          @blur="headerFixed = true"
        >
        </van-field>
      </template>
    </van-cell-group>
    <van-cell-group>
      <div class="rule" v-if="form.collectType">请确保输入的是本人的收款账号，否则可能会导致补偿失败。</div>
      <div class="cell-title">
        考试成绩资料
      </div>
      <van-field
        class="update"
        input-align="right"
        v-model="form.examSysPwd"
        label="122登录密码"
        maxlength="16"
        clearable
        placeholder="请输入122网站密码"
        @focus="headerFixed = false"
        @blur="headerFixed = true"
      >
      </van-field>
      <van-field name="uploader" label="上传成绩单(选填)" input-align="right" class="label-uploader">
        <template #input>
          <div id="uploader">
            <img v-if="form.imgUrl" class="uploader-icon" :src="form.imgUrl" alt="">
            <img v-else class="uploader-icon" src="@/assets/vip/icon_tjcjd.png" alt="">
            <input @change="compress" type="file" accept="image/*" class="uploader-input">
          </div>
        </template>
      </van-field>
    </van-cell-group>
    <div class="rule">请提交www.122.gov.cn官网成绩查询的登录密码，平台承诺仅用于核实考试成绩，不做其他用途。如果考试分数被您最近一次预约考试覆盖，需提交纸质版成绩单照片或122上预约考试截图。</div>
    <template v-if="form.remark">
      <div class="cell-title">
        备注说明
      </div>
      <div class="remark">{{form.remark}}</div>
    </template>
    <div class="bottom">
      <van-button round type="primary" :class="isSubmit || 'disabled'" :loading="loading"
                  :disabled="loading || !isSubmit" @click="submit">提交申请
      </van-button>
    </div>

    <van-action-sheet title="请选择收款方式" v-model="collectTypeShow" :actions="collectTypeActions"
                      @select="collectTypeConfirm"/>
  </div>
</template>

<script>
import { Field, CellGroup, Button, Toast, ActionSheet } from 'vant'
import axios from 'axios'

export default {
    name: 'applyUpdate',
    components: {
        [Button.name]: Button,
        [CellGroup.name]: CellGroup,
        [Field.name]: Field,
        [ActionSheet.name]: ActionSheet,
        [Toast.name]: Toast
    },
    data () {
        return {
            headerFixed: true,
            loading: false,
            isSubmit: false,
            collectTypeShow: false,
            collectTypeActions: [{ name: '支付宝', value: 2, className: 'zfb-icon' }, {
                name: '银行卡',
                value: 5,
                className: 'yhk-icon'
            }],
            form: {
                subject: '',
                vipUserId: '',
                collectType: '',
                bankcardNo: '',
                bankName: '',
                alibNo: '',
                alibName: '',
                examSysPwd: '',
                examSysUrl: '',
                imgUrl: ''
            }
        }
    },
    watch: {
        form: {
            handler () {
                // 判断支付方式
                if (this.form.collectType === 2) {
                    this.isSubmit = !!this.form.collectType && !!this.form.alibNo && !!this.form.alibName && !!this.form.examSysPwd
                } else {
                    this.isSubmit = !!this.form.collectType && !!this.form.bankcardNo && !!this.form.bankName && !!this.form.examSysPwd
                }
            },
            deep: true
        },
        'form.bankcardNo' (val) {
            if (val) {
                this.$nextTick(() => {
                    this.form.bankcardNo = val.replace(/\D/g, '').replace(/....(?!$)/g, '$& ')
                })
            }
        },
        'form.alibName' (val) {
            if (val) {
                this.$nextTick(() => {
                    this.form.alibName = val.replace(/ /g, '')
                })
            }
        }
    },
    methods: {
        compress (v) {
            let file = v.target.files[0]
            if (!file) {
                return
            }
            let _this = this

            Toast.loading({ duration: 3000, overlay: true, message: '上传中...', className: 'ctl-loading' })

            if (v.target.files[0].size < 1024 * 1024) {
                _this.onUploader(file)
                return
            }
            let reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = function (res) {
                let img = new Image()
                img.src = res.target.result
                img.onload = function () { // 图片加载完毕
                    let canvas = document.createElement('canvas')
                    let ctx = canvas.getContext('2d')
                    let width = img.width
                    let height = img.height
                    canvas.width = width
                    canvas.height = height
                    ctx.drawImage(img, 0, 0, width, height)

                    let dateUrl = canvas.toDataURL('image/jpeg', 0.1)

                    let arr = dateUrl.split(','); let mime = arr[0].match(/:(.*?);/)[1]
                    let boldString = atob(arr[1]); let n = boldString.length; let u8arr = new Uint8Array(n)
                    while (n--) {
                        u8arr[n] = boldString.charCodeAt(n)
                    }

                    _this.onUploader(new Blob([u8arr], { type: mime }))
                }
            }
        },
        // 上传
        onUploader (v) {
            Toast.loading({ duration: 0, mask: true, message: '上传中...', className: 'ctl-loading' })
            this.$api.uploadToken().then(res => {
                if (res.status) {
                    const http = axios.create({ withCredentials: false }) // withCredentials 禁止携带cookie，带cookie在七牛上有可能出现跨域问题
                    let file = v
                    let data = new FormData()

                    data.append('token', res.result.upToken) // 七牛需要的token，叫后台给，是七牛账号密码等组成的hash
                    data.append('file', file)
                    data.append('key', `exam/compensate/${new Date().getTime()}.png`)

                    // 发送请求
                    http({
                        method: 'POST',
                        url: '//up-z2.qiniup.com/', // 上传地址
                        data: data,
                        timeout: 60000 // 超时时间，因为图片上传有可能需要很久
                    }).then(xhrData => {
                        this.form.imgUrl = URL.createObjectURL(file)
                        this.form.examSysUrl = xhrData.data.key
                        Toast.clear()
                    }).catch(function () {
                        Toast.fail('上传超时，请重新上传！')
                    })
                }
            })
        },
        // 获取信息
        getInfo () {
            this.$api.compensateDetail({ compensateId: this.form.compensateId }).then(res => {
                if (res.status) {
                    this.form = Object.assign({}, res.result, {
                        imgUrl: res.result.examSysUrl,
                        subjectName: res.result.subject,
                        vipUserId: this.$route.query.vipUserId
                    })
                    this.form.subject = res.result.subject === '科目一' ? 1 : 4
                }
            })
        },
        // 选择收款方式
        collectTypeConfirm (v) {
            this.form.collectType = v.value
            this.collectTypeShow = false
        },
        // 返回
        goBack () {
            this.$router.back()
        },
        // 提交
        submit () {
            if (Number(this.form.collectType) === 5 && this.form.bankName.length < 4) {
                Toast.fail('开户行长度必须大于等于4位！')
                return
            }
            if (this.form.alibNo.match(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g)) {
                Toast.fail('请输入正确的支付宝账号！')
                return
            }

            if (Number(this.form.collectType) === 2) {
                if (/^[\u4e00-\u9fa5]/.test(this.form.alibName) && !(/^[\u4e00-\u9fa5]+$/i.test(this.form.alibName))) {
                    Toast.fail('请输入正确的支付宝实名！')
                    return
                } else if (!(/^[\u4e00-\u9fa5]/.test(this.form.alibName)) && !(/^[a-zA-Z-.]+$/.test(this.form.alibName))) {
                    Toast.fail('请输入正确的支付宝实名！')
                    return
                }
            }

            Toast.loading({ duration: 0, mask: true, message: '加载中...', className: 'ctl-loading' })
            this.$api.compensateEdit(this.form).then(res => {
                Toast.clear()
                if (res.status) {
                    this.$router.replace({
                        name: 'ensureList',
                        query: {
                            vipUserId: this.form.vipUserId,
                            subject: this.form.subject,
                            compensateId: this.form.compensateId
                        }
                    })
                } else {
                    Toast.fail(res.message)
                }
            })
        }
    },
    created () {
        this.form.compensateId = this.$route.query.compensateId

        this.getInfo()
    },
    mounted () {

    }
}
</script>

<style lang="scss" scoped>
  .wrapper {
    overflow: hidden;
    background-color: #fafafa;
  }

  /deep/ {
    .van-cell-group::after {
      border-width: 0;
    }

    .van-cell {
      padding: 20px 15px;
    }

    .van-field__label {
      font-size: 15px;
      font-weight: 400;
      color: #333333;
    }

    .van-field__control::placeholder {
      font-size: 15px;
      font-weight: 400;
      color: #999999;
    }

    .van-field__control {
      font-size: 15px;
      font-weight: 400;
      color: #53CB85;
    }

    .icon-clear {
      width: 18px;
      height: 18px;
    }

    .van-field__body {
      display: flex;
      align-items: center;
    }

    .van-field__right-icon {
      display: flex;
      align-items: center;
    }

    .van-cell:nth-child(4)::after {
      display: none;
    }

    .van-action-sheet__content {
      padding: 0 15px 50px;
    }

    .van-action-sheet__header {
      padding: 20px 0;
      line-height: 1;
      font-size: 18px;
      font-weight: 600;
      color: #333333;

      .van-icon {
        top: 17px;
      }
    }

    .label-uploader {
      padding: 10px 15px;
    }
  }

  .cell-title {
    background-color: #fafafa;
    padding: 15px 15px 10px;
    font-size: 18px;
    font-weight: bold;
    line-height: 1;
    color: #333333;
  }

  .van-button {
    width: 345px;
    height: 43px;
    margin: 15px auto 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.3rem;
    opacity: 1;
    border: 0;
    line-height: 1;
    border-radius: 21px;
    background-color: #53CB85;

    .van-button__text {
      font-size: 17px;
      font-weight: 400;
      color: #FFFFFF;
    }
  }

  .disabled {
    background: #CCCCCC;
  }

  .rule {
    padding: 10px 15px 0;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 24px;
    background-color: #fafafa;
  }

  .zfb-icon {
    padding: 24px 0;
    border-bottom: 1px solid #eee;

    /deep/ .van-action-sheet__name {
      padding-left: 34px;
      background: url('~@/assets/vip/icon_zfb.png') no-repeat;
      background-size: 24px;
      display: inline-block;
      background-position: left center;
    }
  }

  .zfb-value {
    padding-left: 24px;
    background: url('~@/assets/vip/icon_zfb.png') no-repeat center left;
    background-size: 18px;
  }

  .yhk-icon {
    padding: 24px 0;

    /deep/ .van-action-sheet__name {
      padding-left: 34px;
      background: url('~@/assets/vip/icon_yhk.png') no-repeat;
      background-size: 24px;
      display: inline-block;
      background-position: left center;
    }
  }

  .yhk-value {
    padding-left: 24px;
    background: url('~@/assets/vip/icon_yhk.png') no-repeat center left;
    background-size: 18px;
  }

  .uploader-icon {
    display: block;
    width: 80px;
    height: 80px;
    object-fit: cover;
  }

  #uploader {
    position: relative;

    .uploader-input {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
      cursor: pointer;
      opacity: 0;
    }
  }

  .remark {
    margin-bottom: 30px;
    background-color: #fff;
    word-break: break-word;
    padding: 20px 15px;
    font-size: 15px;
    font-weight: 400;
    color: #FF5050;
  }

  .status {
    padding-bottom: 36px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    font-size: 21px;
    font-weight: 400;
    color: #333333;

    .status-icon {
      margin-bottom: 10px;
      width: 100px;
    }
  }

  .update {
    /deep/ .van-field__control {
      color: #333;
    }
  }
</style>
